import { themeUtils } from "../../utils/theme.utils";

const primaryColor = themeUtils.getPrimaryColor();
console.log("primaryColor",primaryColor)
const BookIcon = () => {
  return (
    <svg
      width="30"
      height="33"
      viewBox="0 0 30 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.41464 6.6C7.81464 6.6 7.31708 6.10133 7.31708 5.5V1.1C7.31708 0.498667 7.81464 0 8.41464 0C9.01464 0 9.5122 0.498667 9.5122 1.1V5.5C9.5122 6.10133 9.01464 6.6 8.41464 6.6Z"
        fill="white"
      />
      <path
        d="M20.122 6.6C19.522 6.6 19.0244 6.10133 19.0244 5.5V1.1C19.0244 0.498667 19.522 0 20.122 0C20.722 0 21.2195 0.498667 21.2195 1.1V5.5C21.2195 6.10133 20.722 6.6 20.122 6.6Z"
        fill="white"
      />
      <path
        d="M9.14634 19.4335C8.95609 19.4335 8.76585 19.4041 8.59024 19.3161C8.41463 19.2428 8.25364 19.1401 8.1073 19.0081C7.84388 18.7295 7.68292 18.3481 7.68292 17.9668C7.68292 17.7761 7.72682 17.5855 7.8 17.4095C7.87317 17.2335 7.97559 17.0721 8.1073 16.9255C8.25364 16.7935 8.41463 16.6908 8.59024 16.6175C9.11707 16.3975 9.77562 16.5148 10.1854 16.9255C10.3171 17.0721 10.4195 17.2335 10.4927 17.4095C10.5658 17.5855 10.6098 17.7761 10.6098 17.9668C10.6098 18.3481 10.4488 18.7295 10.1854 19.0081C9.90733 19.2721 9.52682 19.4335 9.14634 19.4335Z"
        fill="white"
      />
      <path
        d="M14.2683 19.4332C13.8878 19.4332 13.5073 19.2718 13.2293 19.0078C13.0976 18.8612 12.9951 18.6998 12.9219 18.5238C12.8488 18.3478 12.8049 18.1572 12.8049 17.9665C12.8049 17.5852 12.9658 17.2038 13.2293 16.9252C13.639 16.5145 14.2829 16.3825 14.8244 16.6172C15 16.6905 15.161 16.7932 15.3073 16.9252C15.5707 17.2038 15.7317 17.5852 15.7317 17.9665C15.7317 18.1572 15.7024 18.3478 15.6146 18.5238C15.5415 18.6998 15.439 18.8612 15.3073 19.0078C15.161 19.1398 15 19.2425 14.8244 19.3158C14.6488 19.4038 14.4585 19.4332 14.2683 19.4332Z"
        fill="white"
      />
      <path
        d="M9.14634 24.5665C8.95609 24.5665 8.76585 24.5225 8.59024 24.4492C8.41463 24.3759 8.25364 24.2732 8.1073 24.1412C7.84388 23.8625 7.68292 23.4959 7.68292 23.0999C7.68292 22.9092 7.72682 22.7185 7.8 22.5425C7.87317 22.3519 7.97559 22.2052 8.1073 22.0585C8.25364 21.9265 8.41463 21.8239 8.59024 21.7505C9.11707 21.5159 9.77562 21.6479 10.1854 22.0585C10.3171 22.2052 10.4195 22.3519 10.4927 22.5425C10.5658 22.7185 10.6098 22.9092 10.6098 23.0999C10.6098 23.4959 10.4488 23.8625 10.1854 24.1412C9.90733 24.4052 9.52682 24.5665 9.14634 24.5665Z"
        fill="white"
      />
      <path
        d="M26.7073 12.5984H1.82925C1.22925 12.5984 0.731689 12.0998 0.731689 11.4984C0.731689 10.8971 1.22925 10.3984 1.82925 10.3984H26.7073C27.3073 10.3984 27.8049 10.8971 27.8049 11.4984C27.8049 12.0998 27.3073 12.5984 26.7073 12.5984Z"
        fill="white"
      />
      <path
        d="M23.0488 33C19.2146 33 16.0975 29.876 16.0975 26.0333C16.0975 22.1907 19.2146 19.0667 23.0488 19.0667C26.8829 19.0667 30 22.1907 30 26.0333C30 29.876 26.8829 33 23.0488 33ZM23.0488 21.2667C20.4292 21.2667 18.2927 23.408 18.2927 26.0333C18.2927 28.6587 20.4292 30.8 23.0488 30.8C25.6683 30.8 27.8049 28.6587 27.8049 26.0333C27.8049 23.408 25.6683 21.2667 23.0488 21.2667Z"
        fill="white"
      />
      <path
        d="M25.2293 27.2064H20.8537C20.2537 27.2064 19.7561 26.7077 19.7561 26.1064C19.7561 25.505 20.2537 25.0064 20.8537 25.0064H25.2293C25.8293 25.0064 26.3268 25.505 26.3268 26.1064C26.3268 26.7077 25.8439 27.2064 25.2293 27.2064Z"
        fill="white"
      />
      <path
        d="M23.0488 29.4504C22.4488 29.4504 21.9512 28.9517 21.9512 28.3504V23.9651C21.9512 23.3637 22.4488 22.8651 23.0488 22.8651C23.6488 22.8651 24.1464 23.3637 24.1464 23.9651V28.3504C24.1464 28.9517 23.6488 29.4504 23.0488 29.4504Z"
        fill="white"
      />
      <path
        d="M19.2 31.5333H8.41463C3.07317 31.5333 0 28.4533 0 23.1V10.6333C0 5.27998 3.07317 2.19998 8.41463 2.19998H20.122C25.4634 2.19998 28.5366 5.27998 28.5366 10.6333V22.1613C28.5366 22.616 28.2585 23.0266 27.8195 23.188C27.3951 23.3493 26.9122 23.232 26.6049 22.88C25.6976 21.8533 24.3951 21.2666 23.0341 21.2666C20.4146 21.2666 18.278 23.408 18.278 26.0333C18.278 26.8986 18.5122 27.7493 18.9659 28.4826C19.2146 28.9226 19.5366 29.2893 19.8878 29.5973C20.239 29.8906 20.3707 30.3746 20.2098 30.8146C20.078 31.24 19.6683 31.5333 19.2 31.5333ZM8.41463 4.39998C4.22927 4.39998 2.19512 6.43865 2.19512 10.6333V23.1C2.19512 27.2946 4.22927 29.3333 8.41463 29.3333H16.9317C16.3902 28.336 16.0976 27.2066 16.0976 26.0333C16.0976 22.1906 19.2146 19.0666 23.0488 19.0666C24.2049 19.0666 25.3463 19.36 26.3415 19.9026V10.6333C26.3415 6.43865 24.3073 4.39998 20.122 4.39998H8.41463Z"
        fill="white"
      />
    </svg>
  );
};

const ProfileIcon = () => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6849 18.8484C16.6542 18.8484 16.6082 18.8484 16.5775 18.8484C16.5314 18.8484 16.47 18.8484 16.424 18.8484C12.9397 18.7409 10.3304 16.0242 10.3304 12.6781C10.3304 9.27066 13.1086 6.49252 16.5161 6.49252C19.9235 6.49252 22.7017 9.27066 22.7017 12.6781C22.6863 16.0395 20.0617 18.7409 16.731 18.8484C16.7003 18.8484 16.7003 18.8484 16.6849 18.8484ZM16.5007 8.7795C14.3519 8.7795 12.6174 10.5293 12.6174 12.6628C12.6174 14.7656 14.2598 16.4693 16.3472 16.546C16.3933 16.5307 16.5468 16.5307 16.7003 16.546C18.757 16.4386 20.3686 14.7502 20.384 12.6628C20.384 10.5293 18.6496 8.7795 16.5007 8.7795Z"
        fill="white"
      />
      <path
        d="M16.5012 33.0001C12.3724 33.0001 8.42776 31.4653 5.37334 28.6718C5.09706 28.4262 4.97427 28.0578 5.00497 27.7048C5.20451 25.8783 6.34032 24.1746 8.22823 22.916C12.8022 19.8769 20.2157 19.8769 24.7743 22.916C26.6622 24.1899 27.798 25.8783 27.9975 27.7048C28.0436 28.0732 27.9054 28.4262 27.6291 28.6718C24.5747 31.4653 20.6301 33.0001 16.5012 33.0001ZM7.41474 27.3978C9.96265 29.5313 13.1706 30.6978 16.5012 30.6978C19.8319 30.6978 23.0398 29.5313 25.5877 27.3978C25.3115 26.4615 24.5747 25.556 23.485 24.8192C19.7091 22.302 13.3087 22.302 9.50218 24.8192C8.41241 25.556 7.69102 26.4615 7.41474 27.3978Z"
        fill="white"
      />
      <path
        d="M16.5 33C7.39814 33 0 25.6019 0 16.5C0 7.39814 7.39814 0 16.5 0C25.6019 0 33 7.39814 33 16.5C33 25.6019 25.6019 33 16.5 33ZM16.5 2.30233C8.67209 2.30233 2.30233 8.67209 2.30233 16.5C2.30233 24.3279 8.67209 30.6977 16.5 30.6977C24.3279 30.6977 30.6977 24.3279 30.6977 16.5C30.6977 8.67209 24.3279 2.30233 16.5 2.30233Z"
        fill="white"
      />
    </svg>
  );
};

const FilesIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill={primaryColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.1458 43.75L38.9062 40.9375L34.0625 36.0937L31.25 38.8542C30.5556 39.5486 30.217 40.3646 30.2344 41.3021C30.2517 42.2396 30.5903 43.0555 31.25 43.75C31.9444 44.4097 32.7604 44.7483 33.6979 44.7656C34.6354 44.783 35.4514 44.4444 36.1458 43.75ZM41.0417 38.8021L43.8542 36.0417C44.5486 35.3472 44.8872 34.5312 44.8698 33.5937C44.8524 32.6562 44.4965 31.8403 43.8021 31.1458C43.1076 30.4514 42.3042 30.1042 41.3917 30.1042C40.4792 30.1042 39.6681 30.4514 38.9583 31.1458L36.1979 33.9583L41.0417 38.8021ZM38.3333 45.9375C37.0486 47.2222 35.5035 47.8646 33.6979 47.8646C31.8924 47.8646 30.3472 47.2222 29.0625 45.9375C27.7778 44.6528 27.1354 43.1076 27.1354 41.3021C27.1354 39.4965 27.7778 37.9514 29.0625 36.6667L36.7708 28.9583C38.0556 27.6736 39.6007 27.0312 41.4062 27.0312C43.2118 27.0312 44.7569 27.6736 46.0417 28.9583C47.3264 30.243 47.9687 31.7882 47.9687 33.5937C47.9687 35.3993 47.3264 36.9444 46.0417 38.2292L38.3333 45.9375ZM9.375 43.75C8.51562 43.75 7.77995 43.444 7.16797 42.832C6.55599 42.22 6.25 41.4844 6.25 40.625V9.37499C6.25 8.51562 6.55599 7.77994 7.16797 7.16796C7.77995 6.55598 8.51562 6.24999 9.375 6.24999H20.0521C20.2257 5.03472 20.7812 4.03645 21.7187 3.2552C22.6562 2.47395 23.75 2.08333 25 2.08333C26.25 2.08333 27.3437 2.47395 28.2812 3.2552C29.2187 4.03645 29.7743 5.03472 29.9479 6.24999H40.625C41.4844 6.24999 42.2201 6.55598 42.832 7.16796C43.444 7.77994 43.75 8.51562 43.75 9.37499V24.1667C43.2292 24.0278 42.7083 23.941 42.1875 23.9062C41.6667 23.8715 41.1458 23.8889 40.625 23.9583V9.37499H9.375V40.625H24.0104C23.9757 41.1458 23.9844 41.6667 24.0365 42.1875C24.0885 42.7083 24.184 43.2292 24.3229 43.75H9.375ZM25 8.48958C25.4861 8.48958 25.9115 8.30729 26.276 7.9427C26.6406 7.57812 26.8229 7.15277 26.8229 6.66666C26.8229 6.18055 26.6406 5.7552 26.276 5.39062C25.9115 5.02604 25.4861 4.84374 25 4.84374C24.5139 4.84374 24.0885 5.02604 23.724 5.39062C23.3594 5.7552 23.1771 6.18055 23.1771 6.66666C23.1771 7.15277 23.3594 7.57812 23.724 7.9427C24.0885 8.30729 24.5139 8.48958 25 8.48958ZM14.5833 17.7083V14.5833H35.4167V17.7083H14.5833ZM14.5833 26.5625V23.4375H35.4167V25.9896C35.3125 26.059 35.1997 26.1458 35.0781 26.25C34.9566 26.3542 34.8437 26.4583 34.7396 26.5625H14.5833ZM14.5833 35.4167V32.2917H29.0104L26.8229 34.4792C26.6493 34.6528 26.5017 34.809 26.3802 34.9479C26.2587 35.0868 26.1285 35.243 25.9896 35.4167H14.5833Z"
        fill={primaryColor}
      />
    </svg>
  );
};

const YoutubeIcon = () => {
  return (
    <svg
      width="38"
      height="31"
      viewBox="0 0 38 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.8372 30.9302H10.1628C4.08279 30.9302 0 26.8474 0 20.7674V10.1628C0 4.08279 4.08279 0 10.1628 0H27.8372C33.9172 0 38 4.08279 38 10.1628V20.7674C38 26.8474 33.9172 30.9302 27.8372 30.9302ZM10.1628 2.65116C5.60279 2.65116 2.65116 5.60279 2.65116 10.1628V20.7674C2.65116 25.3274 5.60279 28.2791 10.1628 28.2791H27.8372C32.3972 28.2791 35.3488 25.3274 35.3488 20.7674V10.1628C35.3488 5.60279 32.3972 2.65116 27.8372 2.65116H10.1628Z"
        fill="white"
      />
      <path
        d="M16.5074 21.7046C15.9948 21.7046 15.5 21.5808 15.058 21.3334C14.0329 20.7501 13.4319 19.566 13.4319 18.099V12.8674C13.4319 11.4004 14.0152 10.2162 15.058 9.63299C16.0832 9.04973 17.4086 9.15572 18.6635 9.91572L23.0293 12.5315C24.2311 13.2562 24.9202 14.3343 24.9202 15.4832C24.9202 16.632 24.2311 17.7101 23.0293 18.4348L18.6635 21.0506C17.9388 21.4748 17.1967 21.7046 16.5074 21.7046ZM16.5074 11.8776C16.4367 11.8776 16.3835 11.8953 16.3481 11.913C16.2244 11.9836 16.083 12.3018 16.083 12.8497V18.0813C16.083 18.6115 16.2244 18.9297 16.3481 19.0181C16.4895 19.0887 16.8255 19.0534 17.2851 18.7706L21.6505 16.1548C22.0923 15.8897 22.2516 15.6246 22.2516 15.4655C22.2516 15.3064 22.0923 15.059 21.6505 14.7762L17.2851 12.1604C16.9669 11.966 16.6841 11.8776 16.5074 11.8776Z"
        fill="white"
      />
    </svg>
  );
};

const HeartIcon = () => {
  return (
    <svg
      width="35"
      height="33"
      viewBox="0 0 35 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 32.8211C17.0116 32.8211 16.5233 32.7072 16.1163 32.4793C13.0721 30.8188 7.71628 29.0606 4.36279 28.6211L3.8907 28.556C1.75814 28.2955 0 26.2932 0 24.1281V4.46299C0 3.17694 0.504651 2.00485 1.43256 1.15834C2.36047 0.311827 3.56512 -0.0951501 4.83488 0.0188034C8.41628 0.295548 13.8209 2.08625 16.8814 4.00718L17.2721 4.23508C17.386 4.3002 17.6302 4.3002 17.7279 4.25136L17.9884 4.08857C21.0488 2.16764 26.4535 0.344385 30.0512 0.0350824H30.2465C31.4349 -0.078871 32.6558 0.344385 33.5674 1.1909C34.4953 2.03741 35 3.2095 35 4.49555V24.1444C35 26.3258 33.2419 28.3118 31.093 28.5723L30.5558 28.6374C27.2023 29.0769 21.8302 30.8513 18.8512 32.4955C18.4605 32.7234 17.9884 32.8211 17.5 32.8211ZM4.44419 2.44439C3.92326 2.44439 3.45116 2.62345 3.07674 2.96532C2.66977 3.33973 2.44186 3.87694 2.44186 4.46299V24.1281C2.44186 25.0886 3.27209 26.0165 4.2 26.1467L4.68837 26.2118C8.35116 26.7002 13.9674 28.5397 17.2233 30.3141C17.3698 30.3793 17.5814 30.3955 17.6628 30.363C20.9186 28.556 26.5674 26.7002 30.2465 26.2118L30.8 26.1467C31.7279 26.0327 32.5581 25.0886 32.5581 24.1281V4.47927C32.5581 3.87694 32.3302 3.35601 31.9233 2.96532C31.5 2.5909 30.9628 2.41183 30.3605 2.44439C30.3279 2.44439 30.1977 2.44439 30.1651 2.44439C27.0558 2.72113 22.0419 4.39787 19.307 6.10718L19.0465 6.28625C18.1512 6.83973 16.8814 6.83973 16.0186 6.30252L15.6279 6.07462C12.8442 4.36532 7.83023 2.70485 4.63953 2.44439C4.57442 2.44439 4.5093 2.44439 4.44419 2.44439Z"
        fill="white"
      />
      <path
        d="M17.5 31.4537C16.8325 31.4537 16.2791 30.9002 16.2791 30.2327V5.81413C16.2791 5.14669 16.8325 4.5932 17.5 4.5932C18.1674 4.5932 18.7209 5.14669 18.7209 5.81413V30.2327C18.7209 30.9165 18.1674 31.4537 17.5 31.4537Z"
        fill="white"
      />
      <path
        d="M10.5815 11.9188H6.91868C6.25124 11.9188 5.69775 11.3653 5.69775 10.6978C5.69775 10.0304 6.25124 9.4769 6.91868 9.4769H10.5815C11.2489 9.4769 11.8024 10.0304 11.8024 10.6978C11.8024 11.3653 11.2489 11.9188 10.5815 11.9188Z"
        fill="white"
      />
      <path
        d="M11.8024 16.8025H6.91868C6.25124 16.8025 5.69775 16.249 5.69775 15.5816C5.69775 14.9141 6.25124 14.3607 6.91868 14.3607H11.8024C12.4698 14.3607 13.0233 14.9141 13.0233 15.5816C13.0233 16.249 12.4698 16.8025 11.8024 16.8025Z"
        fill="white"
      />
    </svg>
  );
};

const TimeIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 60 60"
      fill={primaryColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.0625 29.25V18.5625C32.0625 18.0208 31.8854 17.5729 31.5312 17.2188C31.1771 16.8646 30.7292 16.6875 30.1875 16.6875C29.6458 16.6875 29.1979 16.8646 28.8437 17.2188C28.4896 17.5729 28.3125 18.0208 28.3125 18.5625V30C28.3125 30.25 28.3542 30.4792 28.4375 30.6875C28.5208 30.8958 28.6458 31.1042 28.8125 31.3125L37.8125 40.625C38.1875 41.0417 38.6562 41.2396 39.2187 41.2188C39.7812 41.1979 40.25 41 40.625 40.625C41 40.25 41.1875 39.7917 41.1875 39.25C41.1875 38.7083 41 38.25 40.625 37.875L32.0625 29.25ZM30 55C26.5833 55 23.3542 54.3438 20.3125 53.0312C17.2708 51.7188 14.6146 49.9271 12.3437 47.6562C10.0729 45.3854 8.28125 42.7292 6.96875 39.6875C5.65625 36.6458 5 33.4167 5 30C5 26.5833 5.65625 23.3542 6.96875 20.3125C8.28125 17.2708 10.0729 14.6146 12.3437 12.3438C14.6146 10.0729 17.2708 8.28125 20.3125 6.96875C23.3542 5.65625 26.5833 5 30 5C33.4167 5 36.6458 5.65625 39.6875 6.96875C42.7292 8.28125 45.3854 10.0729 47.6562 12.3438C49.9271 14.6146 51.7187 17.2708 53.0312 20.3125C54.3437 23.3542 55 26.5833 55 30C55 33.4167 54.3437 36.6458 53.0312 39.6875C51.7187 42.7292 49.9271 45.3854 47.6562 47.6562C45.3854 49.9271 42.7292 51.7188 39.6875 53.0312C36.6458 54.3438 33.4167 55 30 55ZM30 51.25C35.8333 51.25 40.8333 49.1667 45 45C49.1667 40.8333 51.25 35.8333 51.25 30C51.25 24.1667 49.1667 19.1667 45 15C40.8333 10.8333 35.8333 8.75 30 8.75C24.1667 8.75 19.1667 10.8333 15 15C10.8333 19.1667 8.75 24.1667 8.75 30C8.75 35.8333 10.8333 40.8333 15 45C19.1667 49.1667 24.1667 51.25 30 51.25Z"
        fill={primaryColor}
      />
    </svg>
  );
};

const AppointmentStatus = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 61 61"
      fill={primaryColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1_89)">
        <path
          d="M48.2917 5.08333H45.75V2.54167C45.75 1.13867 44.6113 0 43.2083 0C41.8053 0 40.6667 1.13867 40.6667 2.54167V5.08333H20.3333V2.54167C20.3333 1.13867 19.1947 0 17.7917 0C16.3887 0 15.25 1.13867 15.25 2.54167V5.08333H12.7083C5.70096 5.08333 0 10.7843 0 17.7917V48.2917C0 55.299 5.70096 61 12.7083 61H48.2917C55.299 61 61 55.299 61 48.2917V17.7917C61 10.7843 55.299 5.08333 48.2917 5.08333ZM48.2917 55.9167H12.7083C8.50442 55.9167 5.08333 52.4956 5.08333 48.2917V25.4167H20.3333C21.7363 25.4167 22.875 24.278 22.875 22.875C22.875 21.472 21.7363 20.3333 20.3333 20.3333H5.08333V17.7917C5.08333 13.5878 8.50442 10.1667 12.7083 10.1667H48.2917C52.4956 10.1667 55.9167 13.5878 55.9167 17.7917V20.3333H40.6667C39.2637 20.3333 38.125 21.472 38.125 22.875C38.125 24.278 39.2637 25.4167 40.6667 25.4167H55.9167V48.2917C55.9167 52.4956 52.4956 55.9167 48.2917 55.9167ZM33.0417 22.875V40.6667C33.0417 42.0697 31.903 43.2083 30.5 43.2083C29.097 43.2083 27.9583 42.0697 27.9583 40.6667V22.875C27.9583 21.472 29.097 20.3333 30.5 20.3333C31.903 20.3333 33.0417 21.472 33.0417 22.875ZM33.0417 48.2917C33.0417 49.6947 31.903 50.8333 30.5 50.8333C29.097 50.8333 27.9583 49.6947 27.9583 48.2917C27.9583 46.8887 29.097 45.75 30.5 45.75C31.903 45.75 33.0417 46.8887 33.0417 48.2917Z"
          fill={primaryColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_89">
          <rect width="61" height="61" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const InvoiceIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 60 60"
      fill={primaryColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.875 55C12.0521 55 10.5026 54.362 9.22656 53.0859C7.95052 51.8099 7.3125 50.2604 7.3125 48.4375V42.5C7.3125 41.9688 7.49219 41.5234 7.85156 41.1641C8.21094 40.8047 8.65625 40.625 9.1875 40.625H15.25V6.625C15.25 6.20833 15.4167 6 15.75 6C16.0833 6 16.4167 6.16667 16.75 6.5L19 8.75L22.0625 5.6875C22.2557 5.47917 22.481 5.375 22.7386 5.375C22.9962 5.375 23.2292 5.47917 23.4375 5.6875L26.4375 8.75L29.5 5.6875C29.6932 5.47917 29.9185 5.375 30.1761 5.375C30.4337 5.375 30.6667 5.47917 30.875 5.6875L33.9375 8.75L37 5.6875C37.1932 5.47917 37.4185 5.375 37.6761 5.375C37.9337 5.375 38.1667 5.47917 38.375 5.6875L41.4375 8.75L44.5 5.6875C44.6932 5.47917 44.9185 5.375 45.1761 5.375C45.4337 5.375 45.6667 5.47917 45.875 5.6875L48.9375 8.75L51.1875 6.5C51.5208 6.16667 51.8542 6 52.1875 6C52.5208 6 52.6875 6.214 52.6875 6.642V48.4375C52.6875 50.2604 52.0495 51.8099 50.7734 53.0859C49.4974 54.362 47.9479 55 46.125 55H13.875ZM46.125 51.25C46.9583 51.25 47.6354 50.9896 48.1562 50.4688C48.6771 49.9479 48.9375 49.2708 48.9375 48.4375V11.25H19V40.625H41.4375C41.9688 40.625 42.4141 40.8047 42.7734 41.1641C43.1328 41.5234 43.3125 41.9688 43.3125 42.5V48.4278C43.3125 49.2676 43.5729 49.9479 44.0938 50.4688C44.6146 50.9896 45.2917 51.25 46.125 51.25ZM24.125 21.125C23.625 21.125 23.1979 20.9375 22.8438 20.5625C22.4896 20.1875 22.3125 19.7396 22.3125 19.2188C22.3125 18.6979 22.4922 18.2604 22.8516 17.9062C23.2109 17.5521 23.6562 17.375 24.1875 17.375H35.4375C35.9688 17.375 36.4141 17.5557 36.7734 17.9172C37.1328 18.2787 37.3125 18.7266 37.3125 19.2609C37.3125 19.7953 37.1328 20.2396 36.7734 20.5938C36.4141 20.9479 35.9688 21.125 35.4375 21.125H24.125ZM24.125 29.5C23.625 29.5 23.1979 29.3125 22.8438 28.9375C22.4896 28.5625 22.3125 28.1146 22.3125 27.5938C22.3125 27.0729 22.4922 26.6354 22.8516 26.2812C23.2109 25.9271 23.6562 25.75 24.1875 25.75H35.4375C35.9688 25.75 36.4141 25.9307 36.7734 26.2922C37.1328 26.6537 37.3125 27.1016 37.3125 27.6359C37.3125 28.1703 37.1328 28.6146 36.7734 28.9688C36.4141 29.3229 35.9688 29.5 35.4375 29.5H24.125ZM43.125 21.125C42.625 21.125 42.1875 20.9375 41.8125 20.5625C41.4375 20.1875 41.25 19.75 41.25 19.25C41.25 18.75 41.4375 18.3125 41.8125 17.9375C42.1875 17.5625 42.625 17.375 43.125 17.375C43.625 17.375 44.0625 17.5625 44.4375 17.9375C44.8125 18.3125 45 18.75 45 19.25C45 19.75 44.8125 20.1875 44.4375 20.5625C44.0625 20.9375 43.625 21.125 43.125 21.125ZM43.125 29.1875C42.625 29.1875 42.1875 29 41.8125 28.625C41.4375 28.25 41.25 27.8125 41.25 27.3125C41.25 26.8125 41.4375 26.375 41.8125 26C42.1875 25.625 42.625 25.4375 43.125 25.4375C43.625 25.4375 44.0625 25.625 44.4375 26C44.8125 26.375 45 26.8125 45 27.3125C45 27.8125 44.8125 28.25 44.4375 28.625C44.0625 29 43.625 29.1875 43.125 29.1875ZM13.8125 51.25H39.5625V44.375H11.0625V48.4375C11.0625 49.2708 11.326 49.9479 11.8531 50.4688C12.3802 50.9896 13.0333 51.25 13.8125 51.25Z"
        fill={primaryColor}
      />
    </svg>
  );
};

const VideoConversationIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 47 47"
      fill={primaryColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1_307)">
        <path
          d="M39.1667 3.91666H7.83335C5.67919 3.91666 3.93627 5.67916 3.93627 7.83332L3.91669 43.0833L11.75 35.25H39.1667C41.3209 35.25 43.0834 33.4875 43.0834 31.3333V7.83332C43.0834 5.67916 41.3209 3.91666 39.1667 3.91666ZM39.1667 31.3333H10.1246L7.83335 33.6246V7.83332H39.1667V31.3333Z"
          fill={primaryColor}
        />
        <path
          d="M15.6667 27.4167H27.4167C28.4938 27.4167 29.375 26.5354 29.375 25.4583V21.5613L33.2917 25.4583V13.7083L29.375 17.6054V13.7083C29.375 12.6313 28.4938 11.75 27.4167 11.75H15.6667C14.5896 11.75 13.7084 12.6313 13.7084 13.7083V25.4583C13.7084 26.5354 14.5896 27.4167 15.6667 27.4167Z"
          fill={primaryColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_307">
          <rect width="47" height="47" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const SupportIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 65 65"
      fill={primaryColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1_269)">
        <path
          d="M56.875 33.0958C56.875 18.2271 45.3375 8.125 32.5 8.125C19.7979 8.125 8.125 18.0104 8.125 33.2583C6.5 34.1792 5.41666 35.9125 5.41666 37.9167V43.3333C5.41666 46.3125 7.85416 48.75 10.8333 48.75H13.5417V32.2292C13.5417 21.7479 22.0187 13.2708 32.5 13.2708C42.9813 13.2708 51.4583 21.7479 51.4583 32.2292V51.4583H29.7917V56.875H51.4583C54.4375 56.875 56.875 54.4375 56.875 51.4583V48.1542C58.4729 47.3146 59.5833 45.6625 59.5833 43.7125V37.4833C59.5833 35.5875 58.4729 33.9354 56.875 33.0958Z"
          fill={primaryColor}
        />
        <path
          d="M24.375 37.9167C25.8708 37.9167 27.0833 36.7041 27.0833 35.2083C27.0833 33.7126 25.8708 32.5 24.375 32.5C22.8792 32.5 21.6667 33.7126 21.6667 35.2083C21.6667 36.7041 22.8792 37.9167 24.375 37.9167Z"
          fill={primaryColor}
        />
        <path
          d="M40.625 37.9167C42.1208 37.9167 43.3333 36.7041 43.3333 35.2083C43.3333 33.7126 42.1208 32.5 40.625 32.5C39.1292 32.5 37.9167 33.7126 37.9167 35.2083C37.9167 36.7041 39.1292 37.9167 40.625 37.9167Z"
          fill={primaryColor}
        />
        <path
          d="M48.75 29.8729C47.45 22.1542 40.7333 16.25 32.6354 16.25C24.4292 16.25 15.6 23.0479 16.3042 33.7188C22.9937 30.9833 28.0312 25.025 29.4667 17.7667C33.0146 24.8896 40.3 29.7917 48.75 29.8729Z"
          fill={primaryColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_269">
          <rect width="65" height="65" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const PatientConsent = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1_243)">
        <path
          d="M24.5 2.04166L6.125 10.2083V22.4583C6.125 33.7896 13.965 44.3858 24.5 46.9583C35.035 44.3858 42.875 33.7896 42.875 22.4583V10.2083L24.5 2.04166ZM38.7917 22.4583C38.7917 26.2354 37.7504 29.9104 35.9742 33.0954L33.0138 30.135C35.6475 26.1742 35.1983 20.7842 31.7071 17.2929C27.7258 13.3117 21.2538 13.3117 17.2725 17.2929C13.2913 21.2742 13.2913 27.7462 17.2725 31.7275C20.7638 35.2188 26.1538 35.6475 30.1146 33.0342L33.6262 36.5458C31.1967 39.445 28.0525 41.6704 24.5 42.7525C16.2925 40.2004 10.2083 31.6867 10.2083 22.4583V12.8625L24.5 6.51291L38.7917 12.8625V22.4583ZM24.5 30.625C21.1108 30.625 18.375 27.8892 18.375 24.5C18.375 21.1108 21.1108 18.375 24.5 18.375C27.8892 18.375 30.625 21.1108 30.625 24.5C30.625 27.8892 27.8892 30.625 24.5 30.625Z"
          fill={primaryColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_243">
          <rect width="49" height="49" fill={primaryColor} />
        </clipPath>
      </defs>
    </svg>
  );
};

const CancelAppointmentIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1_178)">
        <path
          d="M38.7917 6.125H36.75V2.04166H32.6667V6.125H16.3333V2.04166H12.25V6.125H10.2083C7.9625 6.125 6.125 7.9625 6.125 10.2083V38.7917C6.125 41.0375 7.9625 42.875 10.2083 42.875H38.7917C41.0375 42.875 42.875 41.0375 42.875 38.7917V10.2083C42.875 7.9625 41.0375 6.125 38.7917 6.125ZM38.7917 38.7917H10.2083V18.375H38.7917V38.7917ZM10.2083 14.2917V10.2083H38.7917V14.2917H10.2083ZM16.8029 33.5037L18.9671 35.6679L23.9487 30.6862L28.9304 35.6679L31.0946 33.5037L26.1129 28.5221L31.0946 23.5404L28.9304 21.3762L23.9487 26.3579L18.9671 21.3762L16.8029 23.5404L21.7846 28.5221L16.8029 33.5037Z"
          fill={primaryColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_178">
          <rect width="49" height="49" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const PrescriptionIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 -960 960 960"
      fill={primaryColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1_178)">
        <path
          d="m694-120 53-54-93-93-54 53q-20 20-19.5 47t19.5 47q20 19 47 19.5t47-19.5Zm94-95 54-53q20-20 19.5-47T841-362q-20-20-46.28-20T748-362l-53 54 93 93ZM736-78q-37 37-89 37t-89-37q-37-37-37-89t37-89l148-148q37-37 89-37t89 37q37 37 37 89t-37 89L736-78ZM180-180v-600 600Zm0 60q-24.75 0-42.375-17.625T120-180v-600q0-24.75 17.625-42.375T180-840h205q5-35 32-57.5t63-22.5q36 0 63 22.5t32 57.5h205q24.75 0 42.375 17.625T840-780v284q-15-4-30-5t-30 1v-280H180v600h281q-1 15 .5 30t5.5 30H180Zm300-677q14 0 24.5-10.5T515-832q0-14-10.5-24.5T480-867q-14 0-24.5 10.5T445-832q0 14 10.5 24.5T480-797ZM280-620v-60h400v60H280Zm0 170v-60h400v49q-3 2-6.5 5t-6.5 6H280Zm0 170v-60h277l-42 42q-5 5-8.5 9t-7.5 9H280Z"
          fill={primaryColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_173">
          <rect width="49" height="49" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const appstore = () => {
  return (
    <svg
      width="33"
      height="39"
      viewBox="0 0 33 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_83_617)">
        <path
          d="M32.3084 30.3928C31.7159 31.7554 31.0146 33.0096 30.202 34.1627C29.0945 35.7347 28.1876 36.8228 27.4887 37.4271C26.4053 38.4189 25.2445 38.9268 24.0015 38.9557C23.1092 38.9557 22.0331 38.703 20.7804 38.1902C19.5236 37.6798 18.3686 37.4271 17.3125 37.4271C16.205 37.4271 15.0171 37.6798 13.7465 38.1902C12.474 38.703 11.4489 38.9702 10.6651 38.9967C9.47317 39.0472 8.28507 38.5248 7.09914 37.4271C6.34221 36.7699 5.39545 35.6432 4.26127 34.0472C3.04439 32.3428 2.04394 30.3664 1.26017 28.1131C0.420783 25.6793 0 23.3225 0 21.0408C0 18.4272 0.567331 16.173 1.70369 14.2839C2.59676 12.7666 3.78487 11.5697 5.27187 10.691C6.75888 9.8123 8.36559 9.36454 10.0959 9.33589C11.0426 9.33589 12.2842 9.62742 13.8271 10.2004C15.3656 10.7752 16.3535 11.0668 16.7866 11.0668C17.1104 11.0668 18.2078 10.7259 20.0682 10.0463C21.8275 9.41605 23.3123 9.1551 24.5287 9.25789C27.8249 9.5227 30.3012 10.8162 31.948 13.1465C29.0002 14.9245 27.5419 17.4149 27.5709 20.6097C27.5975 23.0981 28.5044 25.1689 30.2867 26.8131C31.0944 27.5763 31.9964 28.1661 33 28.5849C32.7824 29.2132 32.5526 29.8151 32.3084 30.3928ZM24.7488 0.780222C24.7488 2.73067 24.033 4.55179 22.6062 6.23741C20.8844 8.24127 18.8017 9.3992 16.5433 9.21648C16.5145 8.98249 16.4978 8.73622 16.4978 8.47743C16.4978 6.60501 17.3167 4.60114 18.7708 2.96271C19.4967 2.13314 20.4201 1.44337 21.5397 0.893125C22.657 0.351089 23.7138 0.0513322 24.7077 0C24.7367 0.260744 24.7488 0.52153 24.7488 0.780222Z"
          fill="#F4F2FC"
        />
      </g>
      <defs>
        <clipPath id="clip0_83_617">
          <rect width="33" height="39" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const playstore = () => {
  return (
    <svg
      width="39"
      height="22"
      viewBox="0 0 39 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.7445 6.72014L31.9496 1.20029C32.1304 0.890849 32.0211 0.497766 31.714 0.317953C31.407 0.138142 31.0074 0.242681 30.8308 0.552127L27.5836 6.14306C25.1062 5.01818 22.3176 4.39092 19.3186 4.39092C16.3197 4.39092 13.531 5.01817 11.0536 6.14306L7.80653 0.552127C7.62566 0.242681 7.23029 0.138142 6.91904 0.317953C6.60779 0.497766 6.50263 0.890849 6.6835 1.20029L9.88854 6.72014C4.36172 9.69751 0.618283 15.2592 0 21.77H38.6373C38.019 15.2591 34.2755 9.69746 28.7445 6.72014ZM10.448 16.3757C9.55206 16.3757 8.82861 15.6522 8.82861 14.7657C8.82861 13.875 9.55627 13.1558 10.448 13.1558C11.3439 13.1558 12.0673 13.8792 12.0673 14.7657C12.0715 15.6522 11.3439 16.3757 10.448 16.3757ZM28.1852 16.3757C27.2893 16.3757 26.5658 15.6522 26.5658 14.7657C26.5658 13.875 27.2935 13.1558 28.1852 13.1558C29.0811 13.1558 29.8045 13.8792 29.8045 14.7657C29.8087 15.6522 29.0811 16.3757 28.1852 16.3757Z"
        fill="#F4F2FC"
      />
    </svg>
  );
};
export const DashboardIcons = {
  BookIcon,
  ProfileIcon,
  FilesIcon,
  YoutubeIcon,
  HeartIcon,
  TimeIcon,
  AppointmentStatus,
  InvoiceIcon,
  VideoConversationIcon,
  SupportIcon,
  PatientConsent,
  CancelAppointmentIcon,
  PrescriptionIcon,
  appstore,
  playstore,
};
